/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Link, useHistory, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';
import { NotificationManager } from 'react-notifications';
import LoadingOverlay from 'react-loading-overlay';
import Cookies from 'universal-cookie';
import {
  getLinkPayment, getRuleDiscountById,
} from '../../redux/actions/payment';
import { deleteCart } from '../../redux/actions/cart';
import TheLayout from '../../layout/TheLayout';
import ButtonComponent from '../Util/ButtonComponent';
import FormTable from './formTable';
import SuccessModal from '../Util/Modal/SuccessModal';

const keywords = ['TERRA', 'apply', 'お申し込み'];
const cookies = new Cookies();

const Apply = () => {
  const history = useHistory();
  const { search } = history.location;
  const paramsUrl = new URLSearchParams(search);
  let typeLink = paramsUrl.get('typeLink');
  const cartsLocal = useSelector((state) => state.cart.cartsLocal, shallowEqual);
  const total = useSelector((state) => state.cart.total, shallowEqual);
  const customer = useSelector((state) => state.auth.customer, shallowEqual);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn, shallowEqual);
  const accessToken = useSelector((state) => state.auth.accessToken, shallowEqual);
  const payment = useSelector((state) => state.payment, shallowEqual);
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [ruleGroupId, setRuleGroupId] = useState(cookies.get('rule_group_id'));
  const [salesPersonId, setSalesPersonId] = useState(cookies.get('salesperson_id'));
  const [couponCode, setCouponCode] = useState('');
  const [couponName, setCouponName] = useState('');
  const [couponId, setCouponId] = useState(null);
  const [products, setProducts] = useState(cartsLocal);
  const [towerDiscount, setTowerDiscount] = useState(0);
  const [price, setPrice] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [shipping, setShipping] = useState(0);
  const [addressList, setAddressList] = useState([]);
  const [multipleAddress, setMultipleAddress] = useState('0');
  const [otherAddress, setOtherAddress] = useState('0');
  const [displayForm1, setDisplayForm1] = useState('0');
  const [displayForm2, setDisplayForm2] = useState('0');
  const [displayForm3, setDisplayForm3] = useState('0');
  const [displayButton2, setDisplayButton2] = useState('1');
  const [displayButton3, setDisplayButton3] = useState('1');
  const [checked, setChecked] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [isExist150, setIsExist150] = useState(false);
  const [isExist168, setIsExist168] = useState(false);
  const [freeForTheFisstMonthText, setFreeForTheFisstMonthText] = useState('');
  const dispatch = useDispatch();
  // const dateFirstBilling = new Date();
  // dateFirstBilling.setMonth(dateFirstBilling.getMonth() + 1);
  // const month = String(dateFirstBilling.getMonth() + 1).padStart(2, '0');
  // const day = 25;
  // const year = dateFirstBilling.getFullYear();
  // const newDate = `${year}${month}${day}`;
  // form table
  const [formTable, setFormTable] = useState({
    familyName: '',
    firstName: '',
    familyNameKana: '',
    firstNameKana: '',
    phoneNumber: '',
    zipCode: '',
    prefectureId: '0',
    address1: '',
    address2: '',
    email: '',
    companyName: '',
    department: '',
    companyUrl: '',
  });

  const [formTable1, setFormTable1] = useState({
    familyName: '',
    firstName: '',
    familyNameKana: '',
    firstNameKana: '',
    phoneNumber: '',
    zipCode: '',
    prefectureId: '0',
    address1: '',
    address2: '',
    email: '',
    companyName: '',
    department: '',
    companyUrl: '',
  });

  const [formTable2, setFormTable2] = useState({
    familyName: '',
    firstName: '',
    familyNameKana: '',
    firstNameKana: '',
    phoneNumber: '',
    zipCode: '',
    prefectureId: '0',
    address1: '',
    address2: '',
    email: '',
    companyName: '',
    department: '',
    companyUrl: '',
  });

  const [formTable3, setFormTable3] = useState({
    familyName: '',
    firstName: '',
    familyNameKana: '',
    firstNameKana: '',
    phoneNumber: '',
    zipCode: '',
    prefectureId: '0',
    address1: '',
    address2: '',
    email: '',
    companyName: '',
    department: '',
    companyUrl: '',
  });

  // form table error
  const [formTableError, setFormTableError] = useState({
    familyName: '',
    firstName: '',
    familyNameKana: '',
    firstNameKana: '',
    phoneNumber: '',
    zipCode: '',
    prefectureId: '',
    address1: '',
    address2: '',
    email: '',
  });
  const [formTableError1, setFormTableError1] = useState({
    familyName: '',
    firstName: '',
    familyNameKana: '',
    firstNameKana: '',
    phoneNumber: '',
    zipCode: '',
    prefectureId: '',
    address1: '',
    address2: '',
    email: '',
  });
  const [formTableError2, setFormTableError2] = useState({
    familyName: '',
    firstName: '',
    familyNameKana: '',
    firstNameKana: '',
    phoneNumber: '',
    zipCode: '',
    prefectureId: '',
    address1: '',
    address2: '',
    email: '',
  });
  const [formTableError3, setFormTableError3] = useState({
    familyName: '',
    firstName: '',
    familyNameKana: '',
    firstNameKana: '',
    phoneNumber: '',
    zipCode: '',
    prefectureId: '',
    address1: '',
    address2: '',
    email: '',
  });

  // Get discount ruleGroupId
  useEffect(() => {
    // check ruleGroupId
    if (ruleGroupId === undefined) {
      setRuleGroupId(null);
    }
    if (ruleGroupId !== undefined && ruleGroupId !== null
       && ruleGroupId !== process.env.REACT_APP_RULE_GROUP_ID_SPECIAL_DISCOUNT) {
      dispatch(getRuleDiscountById(accessToken, ruleGroupId));
    }
  }, [accessToken, dispatch, ruleGroupId]);
  // Get salesPersonId
  useEffect(() => {
    // check salesPersonId
    if (salesPersonId === undefined) {
      setSalesPersonId(null);
    }
    // else {
    //   dispatch(getRuleDiscountById(accessToken, ruleGroupId));
    // }
  }, [salesPersonId]);

  useEffect(() => {
    setProducts(cartsLocal);
    let discount = 0;
    products.forEach((product) => {
      if (product?.product_id.toLocaleString()
        === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[0].toLocaleString()
        || product?.product_id.toLocaleString()
        === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[1].toLocaleString()) {
        discount = 5400 * product?.count;
      }
    });
    setTowerDiscount(discount);
  }, [cartsLocal, products]);

  useEffect(() => {
    if (multipleAddress === '0') {
      setDisplayForm1('0');
      setDisplayForm2('0');
      setDisplayForm3('0');
      setDisplayButton2('0');
      setDisplayButton3('0');
    }
    if (multipleAddress === '1') {
      if (otherAddress === '0') {
        setDisplayForm1('0');
        setDisplayButton2('1');
      } else {
        setDisplayForm1('1');
        setDisplayButton2('1');
      }
    }
  }, [displayForm1, multipleAddress, otherAddress]);

  useEffect(() => {
    let amountPrice = 0;
    let subscriptionDiscount = payment.discount?.value ? payment.discount?.value : 0;
    products.forEach((product) => {
      if (product?.product_id.toLocaleString()
        === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[0].toLocaleString()
        || product?.product_id.toLocaleString()
        === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[1].toLocaleString()) {
        subscriptionDiscount = 5400 * product?.count;
      }
    });

    if (ruleGroupId != null
      && ruleGroupId === process.env.REACT_APP_RULE_GROUP_ID_SPECIAL_DISCOUNT) {
      amountPrice = price - discount - subscriptionDiscount + shipping;
    } else if (ruleGroupId != null
      && ruleGroupId !== process.env.REACT_APP_RULE_GROUP_ID_SPECIAL_DISCOUNT) {
      amountPrice = price - discount
      - Math.floor((price * (subscriptionDiscount / 100))) + shipping;
    } else {
      amountPrice = price + shipping - discount;
    }
    setTotalPrice(amountPrice);
    // // check ruleGroupId
    // if (ruleGroupId === undefined) {
    //   setRuleGroupId(null);
    // }
    // if (ruleGroupId !== undefined && ruleGroupId !== null) {
    //   dispatch(getRuleDiscountById(accessToken, ruleGroupId));
    // }
  }, [discount, isExist168, payment.discount, price, products, ruleGroupId, shipping]);

  useEffect(() => {
    if (cartsLocal.length <= 0) {
      return;
    }
    // check product 168 is exist carts
    cartsLocal?.forEach((product) => {
      if (product?.product_id.toLocaleString() === process.env.REACT_APP_PRODUCT_ID_LP_1000.split(',')[1].toLocaleString()) {
        setIsExist150(true);
      }
      if (product?.product_id.toLocaleString() === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[1].toLocaleString()) {
        setIsExist168(true);
      }
    });
    if (cartsLocal[0]?.product_categories[0]?.category_name === 'LP'
    || isExist168 || isExist150) {
      const couponCodeRequest = 'coupon_shipping_free';
      fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/coupons/by_coupon_code?coupon_code=${couponCodeRequest}&company_id=${process.env.REACT_APP_COMPANY_ID}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        mode: 'cors',
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.type) {
            setCouponName(data.display_name);
            setCouponId(data.id);
            if (data.type === 'yen') {
              setDiscount(data.value);
            } else {
              setDiscount(Math.floor(price * (data.value / 100)));
            }
          } else {
            setCouponName('');
            setCouponId(null);
            setDiscount(0);
            NotificationManager.error('不正なクーポンコードです');
          }
        })
        .catch((error) => {
          setCouponName('');
          setCouponId(null);
          setDiscount(0);
          NotificationManager.error('不正なクーポンコードです');
        });
    }
    setLoading(false);
  }, [accessToken, cartsLocal, couponCode, isExist150, isExist168, price, products]);

  useEffect(() => {
    const addresses = [];
    if (displayForm1 === '0') {
      if (typeLink === 'signin') {
        const custommerInfo = {
          familyName: customer?.family_name,
          firstName: customer?.first_name,
          familyNameKana: customer?.family_name_kana,
          firstNameKana: customer?.first_name_kana,
          phoneNumber: customer?.phone_number,
          zipCode: customer?.zip_code,
          prefectureId: customer?.prefecture_id,
          address1: customer?.address_first,
          address2: customer?.address_second,
          email: customer?.email,
          companyName: customer?.company_name,
          department: customer?.department,
          companyUrl: customer?.company_url,
        };
        addresses.push(custommerInfo);
      } else {
        addresses.push(formTable);
      }
    }
    if (displayForm1 === '1') {
      addresses.push(formTable1);
    }
    if (displayForm2 === '1') {
      addresses.push(formTable2);
    }
    if (displayForm3 === '1') {
      addresses.push(formTable3);
    }
    setAddressList(addresses);
    // eslint-disable-next-line max-len
  }, [displayForm1, displayForm2, displayForm3, formTable, formTable1, formTable2, formTable3, typeLink, customer]);

  useEffect(() => {
    if (addressList.length === 1) {
      setDisplayButton3('0');
    }
    if (addressList.length >= 1) {
      setPrice(total * addressList.length);
      cartsLocal.forEach((c, i) => {
        products.forEach((p, j) => {
          if (i === j) {
            // eslint-disable-next-line no-param-reassign
            p.count = c.count * addressList.length;
          }
        });
      });
    }
  }, [addressList.length, cartsLocal, products, total]);

  const getMaxProductPrice = () => {
    // getMaxProductPrice in products
    // Return : product has price largest
    const reducer = (accumulator, currentValue) => {
      if (accumulator.price > currentValue.price) {
        return accumulator;
      }
      return currentValue;
    };
    return products?.reduce(reducer, 0);
  };

  useEffect(() => {
    // Get product have price largest
    const product = getMaxProductPrice();
    // Get multiply Cost with amount product item  : item > 5 => s * 2
    const multiplyCost = product.count >= 5 ? 2 : 1;
    if (addressList.length >= 1) {
      let ship = 0;
      addressList.forEach((a) => {
        // let s = 1200;
        let s = 0;
        if (product.price <= 2200) {
          s = 405 * multiplyCost;
        } else {
          s = 1200 * multiplyCost;
        }
        ship += s;
      });
      setShipping(ship);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressList]);

  if (!isLoggedIn && typeLink === 'signin') {
    return <Redirect to="/login?type=purchase" />;
  }

  const handleOnChangeField = (e, formName) => {
    if (formName === 'formTable') {
      setFormTable({ ...formTable, [e.target.name]: e.target.value });
    } else if (formName === 'formTable1') {
      setFormTable1({ ...formTable1, [e.target.name]: e.target.value });
    } else if (formName === 'formTable2') {
      setFormTable2({ ...formTable2, [e.target.name]: e.target.value });
    } else if (formName === 'formTable3') {
      setFormTable3({ ...formTable3, [e.target.name]: e.target.value });
    }
  };

  const setCoupon = () => {
    setLoading(true);
    if (couponCode === '') {
      setCouponName('');
      setCouponId(null);
      setDiscount(0);
    } else {
      fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/coupons/by_coupon_code?coupon_code=${couponCode}&company_id=${process.env.REACT_APP_COMPANY_ID}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        mode: 'cors',
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.type) {
            setCouponName(data.display_name);
            setCouponId(data.id);
            if (data.type === 'yen') {
              setDiscount(data.value);
            } else {
              setDiscount(Math.floor(price * (data.value / 100)));
            }
          } else {
            setCouponName('');
            setCouponId(null);
            setDiscount(0);
            NotificationManager.error('不正なクーポンコードです');
          }
        })
        .catch((error) => {
          setCouponName('');
          setCouponId(null);
          setDiscount(0);
          NotificationManager.error('不正なクーポンコードです');
        });
    }
    setLoading(false);
  };

  const onConfirm = () => {
    let isInvalid = false;
    setFormTableError({
      familyName: '',
      firstName: '',
      familyNameKana: '',
      firstNameKana: '',
      phoneNumber: '',
      zipCode: '',
      prefectureId: '',
      address1: '',
      email: '',
    });
    if (typeLink !== 'signin') {
      if (formTable.familyName === '') {
        setFormTableError((formTableError) => ({ ...formTableError, familyName: '氏を入力してください' }));
        isInvalid = true;
      }
      if (formTable.firstName === '') {
        setFormTableError((formTableError) => ({ ...formTableError, firstName: '名を入力してください' }));
        isInvalid = true;
      }
      if (formTable.familyNameKana === '') {
        setFormTableError((formTableError) => ({ ...formTableError, familyNameKana: 'セイを入力してください' }));
        isInvalid = true;
      }
      if (formTable.firstNameKana === '') {
        setFormTableError((formTableError) => ({ ...formTableError, firstNameKana: 'メイを入力してください' }));
        isInvalid = true;
      }
      if (formTable.phoneNumber === '') {
        setFormTableError((formTableError) => ({ ...formTableError, phoneNumber: '電話番号を入力してください' }));
        isInvalid = true;
      }

      if (formTable.zipCode === '') {
        setFormTableError((formTableError) => ({ ...formTableError, zipCode: '郵便番号を入力してください' }));
        isInvalid = true;
      }
      if (formTable.prefectureId === '0') {
        setFormTableError((formTableError) => ({ ...formTableError, prefectureId: '都道府県を選択してください' }));
        isInvalid = true;
      }
      if (formTable.address1 === '') {
        setFormTableError((formTableError) => ({ ...formTableError, address1: '市区町村を入力してください' }));
        isInvalid = true;
      }
      if (formTable.email === '') {
        setFormTableError((formTableError) => ({ ...formTableError, email: 'メールアドレスを入力してください' }));
        isInvalid = true;
        // eslint-disable-next-line no-useless-escape
      } else if (!formTable.email.match(/^([a-zA-Z0-9])+([a-zA-Z0-9\.+_-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)) {
        setFormTableError((formTableError) => ({ ...formTableError, email: 'メールアドレスが不正です' }));
        isInvalid = true;
      }
    }

    setFormTableError1({
      familyName: '',
      firstName: '',
      familyNameKana: '',
      firstNameKana: '',
      phoneNumber: '',
      zipCode: '',
      prefectureId: '',
      address1: '',
      email: '',
    });
    if (displayForm1 === '1') {
      if (formTable1.familyName === '') {
        setFormTableError1((formTableError1) => ({ ...formTableError1, familyName: '氏を入力してください' }));
        isInvalid = true;
      }
      if (formTable1.firstName === '') {
        setFormTableError1((formTableError1) => ({ ...formTableError1, firstName: '名を入力してください' }));
        isInvalid = true;
      }
      if (formTable1.familyNameKana === '') {
        setFormTableError1((formTableError1) => ({ ...formTableError1, familyNameKana: 'セイを入力してください' }));
        isInvalid = true;
      }
      if (formTable1.firstNameKana === '') {
        setFormTableError1((formTableError1) => ({ ...formTableError1, firstNameKana: 'メイを入力してください' }));
        isInvalid = true;
      }
      if (formTable1.phoneNumber === '') {
        setFormTableError1((formTableError1) => ({ ...formTableError1, phoneNumber: '電話番号を入力してください' }));
        isInvalid = true;
      }
      if (formTable1.zipCode === '') {
        setFormTableError1((formTableError1) => ({ ...formTableError1, zipCode: '郵便番号を入力してください' }));
        isInvalid = true;
      }
      if (formTable1.prefectureId === '0') {
        setFormTableError1((formTableError1) => ({ ...formTableError1, prefectureId: '都道府県を選択してください' }));
        isInvalid = true;
      }
      if (formTable1.address1 === '') {
        setFormTableError1((formTableError1) => ({ ...formTableError1, address1: '市区町村を入力してください' }));
        isInvalid = true;
      }
      if (formTable1.email === '') {
        setFormTableError1((formTableError1) => ({ ...formTableError1, email: 'メールアドレスを入力してください' }));
        isInvalid = true;
        // eslint-disable-next-line no-useless-escape
      } else if (!formTable1.email.match(/^([a-zA-Z0-9])+([a-zA-Z0-9\.+_-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)) {
        setFormTableError1((formTableError1) => ({ ...formTableError1, email: 'メールアドレスが不正です' }));
        isInvalid = true;
      }
    }

    setFormTableError2({
      familyName: '',
      firstName: '',
      familyNameKana: '',
      firstNameKana: '',
      phoneNumber: '',
      zipCode: '',
      prefectureId: '',
      address1: '',
      email: '',
    });
    if (displayForm2 === '1') {
      if (formTable2.familyName === '') {
        setFormTableError2((formTableError2) => ({ ...formTableError2, familyName: '氏を入力してください' }));
        isInvalid = true;
      }
      if (formTable2.firstName === '') {
        setFormTableError2((formTableError2) => ({ ...formTableError2, firstName: '名を入力してください' }));
        isInvalid = true;
      }
      if (formTable2.familyNameKana === '') {
        setFormTableError2((formTableError2) => ({ ...formTableError2, familyNameKana: 'セイを入力してください' }));
        isInvalid = true;
      }
      if (formTable2.firstNameKana === '') {
        setFormTableError2((formTableError2) => ({ ...formTableError2, firstNameKana: 'メイを入力してください' }));
        isInvalid = true;
      }
      if (formTable2.phoneNumber === '') {
        setFormTableError2((formTableError2) => ({ ...formTableError2, phoneNumber: '電話番号を入力してください' }));
        isInvalid = true;
      }
      if (formTable2.zipCode === '') {
        setFormTableError2((formTableError2) => ({ ...formTableError2, zipCode: '郵便番号を入力してください' }));
        isInvalid = true;
      }
      if (formTable2.prefectureId === '0') {
        setFormTableError2((formTableError2) => ({ ...formTableError2, prefectureId: '都道府県を選択してください' }));
        isInvalid = true;
      }
      if (formTable2.address1 === '') {
        setFormTableError2((formTableError2) => ({ ...formTableError2, address1: '市区町村を入力してください' }));
        isInvalid = true;
      }
      if (formTable2.email === '') {
        setFormTableError2((formTableError2) => ({ ...formTableError2, email: 'メールアドレスを入力してください' }));
        isInvalid = true;
        // eslint-disable-next-line no-useless-escape
      } else if (!formTable2.email.match(/^([a-zA-Z0-9])+([a-zA-Z0-9\.+_-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)) {
        setFormTableError2((formTableError2) => ({ ...formTableError2, email: 'メールアドレスが不正です' }));
        isInvalid = true;
      }
    }

    setFormTableError3({
      familyName: '',
      firstName: '',
      familyNameKana: '',
      firstNameKana: '',
      phoneNumber: '',
      zipCode: '',
      prefectureId: '',
      address1: '',
      email: '',
    });
    if (displayForm3 === '1') {
      if (formTable3.familyName === '') {
        setFormTableError3((formTableError3) => ({ ...formTableError3, familyName: '氏を入力してください' }));
        isInvalid = true;
      }
      if (formTable3.firstName === '') {
        setFormTableError3((formTableError3) => ({ ...formTableError3, firstName: '名を入力してください' }));
        isInvalid = true;
      }
      if (formTable3.familyNameKana === '') {
        setFormTableError3((formTableError3) => ({ ...formTableError3, familyNameKana: 'セイを入力してください' }));
        isInvalid = true;
      }
      if (formTable3.firstNameKana === '') {
        setFormTableError3((formTableError3) => ({ ...formTableError3, firstNameKana: 'メイを入力してください' }));
        isInvalid = true;
      }
      if (formTable3.phoneNumber === '') {
        setFormTableError3((formTableError3) => ({ ...formTableError3, phoneNumber: '電話番号を入力してください' }));
        isInvalid = true;
      }
      if (formTable3.zipCode === '') {
        setFormTableError3((formTableError3) => ({ ...formTableError3, zipCode: '郵便番号を入力してください' }));
        isInvalid = true;
      }
      if (formTable3.prefectureId === '0') {
        setFormTableError3((formTableError3) => ({ ...formTableError3, prefectureId: '都道府県を選択してください' }));
        isInvalid = true;
      }
      if (formTable3.address1 === '') {
        setFormTableError3((formTableError3) => ({ ...formTableError3, address1: '市区町村を入力してください' }));
        isInvalid = true;
      }
      if (formTable3.email === '') {
        setFormTableError3((formTableError3) => ({ ...formTableError3, email: 'メールアドレスを入力してください' }));
        isInvalid = true;
        // eslint-disable-next-line no-useless-escape
      } else if (!formTable3.email.match(/^([a-zA-Z0-9])+([a-zA-Z0-9\.+_-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)) {
        setFormTableError3((formTableError3) => ({ ...formTableError3, email: 'メールアドレスが不正です' }));
        isInvalid = true;
      }
    }
    if (!isInvalid) {
      if (total > 0) {
        setLoading(true);
      }
      if (typeLink === 'signin') {
        typeLink = null;
      }
      const domain = `${window.location.protocol}//${window.location.host}`;
      const addressesJson = [];
      // eslint-disable-next-line array-callback-return
      addressList.map((a) => {
        addressesJson.push({
          family_name: a.familyName,
          first_name: a.firstName,
          family_name_kana: a.familyNameKana,
          first_name_kana: a.firstNameKana,
          phone_number: a.phoneNumber,
          zip_code: a.zipCode,
          prefecture_id: Number(a.prefectureId),
          address_first: a.address1,
          address_second: a.address2,
          email: a.email,
          company_name: a.companyName,
          department: a.department,
          company_url: a.companyUrl,
        });
      });
      // eslint-disable-next-line prefer-const
      let firstBillingDate = '';
      // eslint-disable-next-line max-len
      // eslint-disable-next-line no-irregular-whitespace
      // if (products[0]?.name === 'タワー型噴霧器　TERRA FORESTAミスト') {
      //   firstBillingDate = newDate;
      // }
      if (typeLink === null) {
        products.forEach((item, index) => {
          if (item.product_id.toLocaleString()
          === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[0].toLocaleString()
          || item.product_id.toLocaleString()
          === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[1].toLocaleString()) {
            products.splice(index, 1);
            products.unshift(item);
          }
        });
        if (products[0]?.product_id.toLocaleString()
        === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[0].toLocaleString()
        || isExist168) {
          fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/customers/sbp/terra/settlement/subscription`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({
              company_id: Number(process.env.REACT_APP_COMPANY_ID),
              first_billing_date: firstBillingDate,
              last_billing_date: '209912',
              cycle_type: 'month',
              cycle_value: 1,
              subscription_date: 25,
              price,
              old_price: price,
              shipping,
              tax: 0,
              coupon_id: couponId,
              cust_code: '',
              products,
              salesperson_id: parseInt(salesPersonId, 10),
              addresses: addressesJson,
              rule_group_id: parseInt(ruleGroupId, 10),
            }),
            mode: 'cors',
          })
            .then((response) => {
              if (response.status === 200) {
                dispatch(deleteCart(accessToken, isLoggedIn));
                setIsSuccess(true);
              } else {
                NotificationManager.error('購入に失敗しました。\n時間をおいてもう一度お試しください');
              }
              setLoading(false);
            })
            .catch((error) => {
              NotificationManager.error('購入に失敗しました。\n時間をおいてもう一度お試しください');
              setLoading(false);
            });
        } else if (products[0]?.product_categories[0]?.category_name === '定期便' || products[0]?.product_categories[0]?.category_name === 'LP') {
          // eslint-disable-next-line max-len
          // fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/customers/sbp/settlement/subscription_with_date`, {
          fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/customers/sbp/settlement/subscription`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({
              company_id: Number(process.env.REACT_APP_COMPANY_ID),
              first_billing_date: firstBillingDate,
              last_billing_date: '209912',
              cycle_type: 'month',
              cycle_value: 1,
              subscription_date: 25,
              price,
              old_price: price,
              shipping,
              tax: 0,
              coupon_id: couponId,
              cust_code: '',
              products,
              salesperson_id: parseInt(salesPersonId, 10),
              addresses: addressesJson,
              rule_group_id: parseInt(ruleGroupId, 10),
            }),
            mode: 'cors',
          })
            .then((response) => {
              if (response.status === 200) {
                dispatch(deleteCart(accessToken, isLoggedIn));
                setIsSuccess(true);
              } else {
                NotificationManager.error('購入に失敗しました。\n時間をおいてもう一度お試しください');
              }
              setLoading(false);
            })
            .catch((error) => {
              NotificationManager.error('購入に失敗しました。\n時間をおいてもう一度お試しください');
              setLoading(false);
            });
        } else {
          fetch(`${process.env.REACT_APP_ENDPOINT}/api/v1/customers/sbp/settlement`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({
              company_id: Number(process.env.REACT_APP_COMPANY_ID),
              price,
              old_price: price,
              shipping,
              tax: 0,
              coupon_id: couponId,
              cust_code: '',
              products,
              salesperson_id: parseInt(salesPersonId, 10),
              addresses: addressesJson,
              rule_group_id: parseInt(ruleGroupId, 10),
            }),
            mode: 'cors',
          })
            .then((response) => {
              if (response.status === 200) {
                dispatch(deleteCart(accessToken, isLoggedIn));
                setIsSuccess(true);
              } else {
                NotificationManager.error('購入に失敗しました。\n時間をおいてもう一度お試しください');
              }
              setLoading(false);
            })
            .catch((error) => {
              NotificationManager.error('購入に失敗しました。\n時間をおいてもう一度お試しください');
              setLoading(false);
            });
        }
      } else {
        const params = {
          redirect_url: `${domain}/product`,
          addresses: addressesJson,
          form_item: {
            customer_name: 2,
            email: 2,
            customer_name_kana: 2,
            phone_number: 2,
            zip_code: 2,
            prefecture_id: 2,
            address_first: 2,
            address_second: 2,
            address_third: 3,
            company_name: 1,
            department: 1,
            company_url: 1,
            coupon_code: 1,
            type: 3,
            gender: 3,
          },
          customer: {
            family_name: formTable.familyName,
            first_name: formTable.firstName,
            family_name_kana: formTable.familyNameKana,
            first_name_kana: formTable.firstNameKana,
            phone_number: formTable.phoneNumber,
            zip_code: formTable.zipCode,
            prefecture_id: Number(formTable.prefectureId),
            address_first: formTable.address1,
            address_second: formTable.address2,
            email: formTable.email,
            company_name: formTable.companyName,
            department: formTable.department,
            company_url: formTable.companyUrl,
          },
          products,
          price,
          coupon_code: products[0]?.product_categories[0]?.category_name === 'LP' || isExist168 || isExist150 ? 'coupon_shipping_free' : null,
          original_price: products[0]?.product_categories[0]?.category_name === 'LP' || isExist168 || isExist150 ? 'coupon_shipping_free' : null,
          is_subscription: products[0]?.product_categories[0]?.category_name === '定期便' || products[0]?.product_categories[0]?.category_name === 'LP',
          shipping,
          type_link: typeLink,
          first_billing_date: firstBillingDate,
          rule_group_id: parseInt(ruleGroupId, 10),
          salesperson_id: parseInt(salesPersonId, 10),
        };
        dispatch(getLinkPayment(accessToken, isLoggedIn, params));
      }
    }
  };

  return (
    <LoadingOverlay
      active={loading}
      spinner
      text="Loading..."
    >
      <TheLayout>
        <Helmet
          meta={[{
            name: 'keyword',
            content: keywords.join(),
          }]}
        >
          <title>お客さま情報｜株式会社TERRA</title>
        </Helmet>
        <div className="apply">
          <div className="d-none d-lg-block bg-white">
            <div className="container pl-0">
              <nav>
                <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                  <li className="breadcrumb-item">
                    <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                    <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/cart">カート</Link>
                  </li>
                  <li className="mx-2">&#62;</li>
                  <li className="breadcrumb-item">
                    <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/cart">カート</Link>
                  </li>
                  <li className="mx-2">&#62;</li>
                  <li>お客さま情報</li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="apply container pb-5">
            <div className="mb-4 pt-4" style={{ color: '#224B71', borderBottom: '2px solid #224B71' }}>お客さま情報</div>
            {
              typeLink === 'signin'
                ? (
                  <>
                    <div style={{
                      maxWidth: '800px',
                      margin: '0 auto',
                      backgroundColor: 'white',
                      padding: '20px 20px',
                    }}
                    >
                      <Row className="border-bottom pb-3 mb-3">
                        <Col xs={4}>
                          <p>基本情報</p>
                        </Col>
                        {' '}
                        <Col>
                          {customer.name}
                          <br />
                          {`〒${customer?.zip_code || ''}`}
                          <br />
                          {customer?.prefecture || ''}
                          県
                          {customer?.address_first || ''}
                          市
                          {customer?.address_second || ''}
                          {customer?.address_third || ''}
                        </Col>
                      </Row>
                      <Row className="border-bottom mb-3">
                        <Col xs={4}>
                          <p>メールアドレス</p>
                        </Col>
                        {' '}
                        <Col>
                          {customer.email}
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={4}>
                          <p>電話番号</p>
                        </Col>
                        {' '}
                        <Col>
                          {customer.phone_number}
                        </Col>
                      </Row>
                    </div>
                  </>
                )
                : (
                  <>
                    <div className="pb-5 pt-5">
                      <div className="text-center pb-5">
                        <span style={{ color: 'red' }}>必須項目</span>
                        <span style={{ color: '#224B71' }}>を記入の上新規お申し込みください。</span>
                      </div>
                      <FormTable
                        form={formTable}
                        formError={formTableError}
                        onChange={(e) => handleOnChangeField(e, 'formTable')}
                      />
                    </div>
                  </>
                )
            }
            <div className="mb-4 mt-4" style={{ color: '#224B71', borderBottom: '2px solid #224B71' }}>商品の配送先</div>
            <div>
              <Row onChange={(e) => setMultipleAddress(e.target.value)}>
                <Col lg={6}>
                  <FormGroup style={{ marginLeft: '1.25rem' }}>
                    <Input type="radio" name="multipleAddress" value="0" defaultChecked />
                    {' '}
                    上記の住所へ配送する
                  </FormGroup>
                </Col>
                <Col lg={6}>
                  <FormGroup style={{ marginLeft: '1.25rem' }}>
                    <Input type="radio" name="multipleAddress" value="1" />
                    {' '}
                    複数の住所へ配送する（3ヶ所まで）
                  </FormGroup>
                </Col>
              </Row>
              {
                multipleAddress === '1'
                  ? (
                    <>
                      <h4>配送先 1</h4>
                      <Row onChange={(e) => {
                        setOtherAddress(e.target.value);
                        setDisplayForm2('0');
                        setDisplayForm3('0');
                        setDisplayButton2('0');
                        setDisplayButton3('0');
                      }}
                      >
                        <Col lg={6}>
                          <FormGroup style={{ marginLeft: '1.25rem' }}>
                            <Input type="radio" name="otherAddress" value="0" defaultChecked={multipleAddress === '1' && otherAddress === '0'} />
                            {' '}
                            上記の住所へ配送する
                          </FormGroup>
                        </Col>
                        <Col lg={6}>
                          <FormGroup style={{ marginLeft: '1.25rem' }}>
                            <Input type="radio" name="otherAddress" value="1" defaultChecked={multipleAddress === '1' && otherAddress === '1'} />
                            {' '}
                            別の住所へ配送する
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  )
                  : ''
              }
              {
                displayForm1 === '1'
                  ? (
                    <FormTable
                      form={formTable1}
                      formError={formTableError1}
                      onChange={(e) => handleOnChangeField(e, 'formTable1')}
                    />
                  )
                  : ''
              }
              {
                displayButton2 === '1'
                  ? (
                    <div className="text-center pt-3">
                      <Button
                        onClick={() => {
                          setDisplayForm2('1');
                          setDisplayButton2('0');
                          setDisplayButton3('1');
                        }}
                      >
                        配送先を追加する
                      </Button>
                    </div>
                  )
                  : ''
              }
              {
                displayForm2 === '1'
                  ? (
                    <>
                      <h4 className="mt-3">配送先 2</h4>
                      <Button
                        className="mb-3"
                        onClick={() => {
                          setDisplayForm2('0');
                          setDisplayButton2('1');
                        }}
                      >
                        削除
                      </Button>
                      <FormTable
                        form={formTable2}
                        formError={formTableError2}
                        onChange={(e) => handleOnChangeField(e, 'formTable2')}
                      />
                    </>
                  )
                  : ''
              }
              {
                displayButton3 === '1' && displayForm3 === '0'
                  ? (
                    <div className="text-center pt-3">
                      <Button
                        onClick={() => {
                          setDisplayForm3('1');
                          setDisplayButton3('0');
                        }}
                      >
                        配送先を追加する
                      </Button>
                    </div>
                  )
                  : ''
              }
              {
                displayForm3 === '1'
                  ? (
                    <>
                      <h4 className="mt-3">配送先 3</h4>
                      <Button
                        className="mb-3"
                        onClick={() => {
                          setDisplayForm3('0');
                          setDisplayButton3('1');
                        }}
                      >
                        削除
                      </Button>
                      <FormTable
                        form={formTable3}
                        formError={formTableError3}
                        onChange={(e) => handleOnChangeField(e, 'formTable3')}
                      />
                    </>
                  )
                  : ''
              }
            </div>
            <div className="mb-4 mt-4" style={{ color: '#224B71', borderBottom: '2px solid #224B71' }}>合計金額</div>
            <div>
              <div style={{ maxWidth: '300px', margin: '0 auto' }}>
                <Row>
                  <Col>
                    <p>商品合計(税込)</p>
                    <p>送料</p>
                    <p>{couponName}</p>
                    {
                      ruleGroupId !== null
                      && (
                      <p>値引</p>
                      )
                    }
                  </Col>
                  <Col>
                    <p>{`￥ ${price.toLocaleString()}`}</p>
                    <p>{`￥ ${shipping.toLocaleString()}`}</p>
                    <p>{discount !== 0 ? `-￥ ${discount.toLocaleString()}` : ''}</p>
                    {
                      (
                        (ruleGroupId !== null
                        && products[0]?.product_id?.toLocaleString()
                        === process.env.REACT_APP_PRODUCT_ID_SPECIAL_DISCOUNT.split(',')[0].toLocaleString())
                        || isExist168)
                        ? (
                          <p>{`-￥ ${towerDiscount.toLocaleString()}`}</p>
                        ) : (
                          <p>{(payment.discount?.value && payment.discount?.value !== 0) ? `-￥ ${(price * (payment.discount?.value / 100))?.toLocaleString()}` : ''}</p>
                        )
                  }
                  </Col>
                </Row>
                <Row>
                  {
                    ruleGroupId !== null
                    && ruleGroupId === process.env.REACT_APP_RULE_GROUP_ID_SPECIAL_DISCOUNT
                    && (
                      <p style={{ paddingLeft: 15 }}>
                        初回は5,400円の値引きが適用されます
                        <br />
                        ※2ヶ月目以降は10%の値引きが適用されます。
                      </p>
                    )
                  }
                  {
                    ruleGroupId !== null
                    && ruleGroupId !== process.env.REACT_APP_RULE_GROUP_ID_SPECIAL_DISCOUNT
                    && (
                      <p style={{ paddingLeft: 15 }}>
                        {`毎月${payment.discount?.value}％の値引きが適用されます。`}
                      </p>
                    )
                  }
                </Row>
                <div className="mb-4 mt-4" style={{ color: '#224B71', borderBottom: '2px solid #224B71' }} />
                <Row>
                  <Col>
                    <p>商品合計(税込)</p>
                  </Col>
                  <Col>
                    <p>{`￥ ${totalPrice.toLocaleString()} `}</p>
                  </Col>
                </Row>
              </div>
              <br />
              {
                ((products[0]?.product_categories[0]?.category_name !== 'LP' && !isExist168 && !isExist150) && typeLink === 'signin') && (
                  <>
                    <p className="text-center">※クーポンをお持ちの場合は、クーポンコードをご⼊⼒ください</p>
                    <div style={{ maxWidth: '400px', margin: '0 auto' }}>
                      <Input
                        onChange={(e) => setCouponCode(e.currentTarget.value)}
                        type="text"
                        name="coupon"
                        value={couponCode}
                      />
                      <Button
                        style={{
                          width: '100%', backgroundColor: '#214b71', border: 'none', marginTop: '4px',
                        }}
                        onClick={() => setCoupon()}
                      >
                        クーポン適応
                      </Button>
                    </div>
                  </>
                )
              }
              {
                (products[0]?.product_categories[0]?.category_name !== 'LP' && typeLink !== 'signin') && (
                  <p className="text-center">※クーポンをお持ちの場合、決済画⾯にてクーポンコードをご⼊⼒ください</p>
                )
              }
              <br />
              <FormGroup check className="text-center">
                <Label check>
                  <Input
                    type="checkbox"
                    value={checked}
                    onChange={() => setChecked(!checked)}
                  />
                  {' '}
                  <Link style={{ color: 'red' }} to="/terms">ご利用規約</Link>
                  を確認しました。
                </Label>
              </FormGroup>
              {' '}

            </div>
            <div className="pt-5" style={{ maxWidth: '300px', margin: '0 auto' }}>
              <ButtonComponent
                background="#224B71"
                borderColor="#224B71"
                color="white"
                disabled={!checked}
                onClick={() => onConfirm()}
              >
                {typeLink === 'signin' ? '購入する' : '確認する'}
              </ButtonComponent>
              <br />
              <ButtonComponent
                background="white"
                borderColor="#224B71"
                color="#224B71"
                width="80%"
                onClick={() => history.push('/product')}
              >
                商品ページへ戻る
              </ButtonComponent>
            </div>
          </div>
        </div>
      </TheLayout>

      <SuccessModal
        isOpen={isSuccess}
        onclickOK={() => {
          setIsSuccess(false);
          history.push('/');
        }}
        message="購入が完了しました！"
      />
    </LoadingOverlay>
  );
};
export default Apply;
